<template>
  <article class="store-detail-box">
    <h2>{{name}}のチラシ・特売情報</h2>
    <div class="store-flyer">
      <div v-if="isLoading" class="store-flyer-loading">
        <span class="text">読み込み中...</span>
      </div>
      <div v-else-if="isError" class="store-flyer-no-print error">
        ただいまアクセスが集中しているために、つながりにくくなっています。<br/>大変申し訳ありませんが、少し時間をおいて再度アクセスしてみて下さい。
      </div>
      <div v-else-if="flyers.length === 0" class="store-flyer-no-print">
        ただいま掲載中のチラシはございません。<br>次の掲載をお楽しみに！
      </div>
      <div class="store-flyer-cp">
        <div class="chirashiplus">
          <div class="flyer" v-for="flyer in flyers" :key="flyer.ext_id">
            <div class="thumbnail">
              <a :href="convertFlyerUrl(flyer.flyerurl)" target="_blank">
                <figure class="img">
                  <img :src="flyer.thumbnail">
                  <figcaption class="img-text">詳しく見る</figcaption>
                </figure>
                <p class="title" v-html="flyer.title.replace('@', '<br/>')"></p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
  import { ref, onMounted } from 'vue'
  import axios from 'axios'
  // @ts-expect-error　型定義がない？
  import jsonAdapter from 'axios-jsonp'
  import { format } from 'date-fns'

  declare global {
    interface Window {
      axiosJsonpAdapter: any;
    }
  }

  interface Props {
     mechaoStoreId: string
     name: string
  }

  type Flyer = {
    ext_id: string;
    title: string;
    from: string;
    to: string;
    thumbnail: string;
    flyerurl: string;
    pdfurl: string;
  }

  const props = defineProps<Props>()

  const flyers = ref<Flyer[]>([])
  const isLoading = ref(true)
  const isError = ref(false)

  onMounted(async () => {
    //　チラシ情報を取得
    try {
      const rs = await axios.get<{ flyers: Flyer[] }>(
        `//cms.mechao.tv/beisia_koukoku/jsonp_flyer?s=${props.mechaoStoreId}&tsp=${format(new Date(), 'yyyyMMddHHmmss')}`,
        { adapter: jsonAdapter }
      )
      flyers.value = rs.data.flyers
    } catch (e) {
      isError.value = true
      console.warn(e)
    } finally {
      isLoading.value = false
    }
  })

  // URLの置換 (template内で実行すると期待通りに動作しない)
  const convertFlyerUrl = (url: string) => url.replace(/&amp;/g, '&')
</script>
<style lang="scss">
.store-detail-box {
  max-width: 1024px;
  margin: 0 auto 40px;
  .chirashiplus {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    a {
      text-decoration: none !important;
      .title {
        font-size: 15px;
        color: #333;
        margin: 0;
      }
      .img {
        border: 1px solid #dadada;
        min-height: 80px;
        box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.1);
        aspect-ratio: 320 / 227;
        img {
          display: block;
          margin: 0 auto;
          height: 100%;
        }
      }
    }
  }
  @media only screen and (min-width: 678px) {
    .chirashiplus {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  .store-flyer-loading {
    .text {
      font-size: 14px;
    }
  }
  .store-flyer-no-print {
    margin-block: 40px;
    text-align: center;
    line-height: 1.7;
    color: #333;
    &.error {
      color: #d63b3f;
      font-weight: bold;
    }
  }
}
</style>
